import dayjs from "dayjs";
import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { post_user_tracking } from "../API/dataProvider";
import { Config, EventId, TrackingType } from "../config";
import { useRecoilValue } from "recoil";
import { userLocationAtom, UUIDAtom } from "../Recoil/Atom";
import { ReturnScalledImg } from "../helper";
import { v4 as uuidv4 } from "uuid";

function OfferCard({ item }) {
  const userLocation = useRecoilValue(userLocationAtom);
  const UUID = useRecoilValue(UUIDAtom);
  const tracking = () => {
    post_user_tracking(
      TrackingType.BROCHURE_CLICK,
      EventId.SHOW_SIMILAR_CARD,
      item.offer_id,
      userLocation,
      undefined,
      UUID,
      window.location.href,
      undefined,
      undefined,
      uuidv4()
    );
  };
  return (
    <Link to={`${Config.brochure_route}?id=${item.offer_id}`} onClick={tracking}>
      <div className="px-2 py-3 bg-white rounded-lg cursor-pointer md:px-3 md:py-4 shadow-offer-card">
        <div className="mb-4 text-center md:mb-6 sm:h-[180px]">
          <LazyLoadImage
            className="max-h-[90px] md:max-h-[180px] mx-auto"
            src={ReturnScalledImg(item.image)}
            alt={item.title}
            loading="lazy"
            effect="blur"
            delayMethod={"debounce"}
          />
        </div>
        <div className="mb-4 md:mb-6">
          <h2 className="mb-2 text-sm font-bold text-primary">{item.title}</h2>
          <p className="text-xs text-opacity-50 sm:text-sm text-dark h-4">
            {item.end_date ? "Gültig bis: " + dayjs(item.end_date).format("DD.MM.YYYY") : ""}
          </p>
        </div>
        <button className="w-full max-w-full px-4 py-2 text-xs font-bold text-white uppercase transition-all duration-300 rounded-md sm:text-sm bg-primary drop-shadow-btn-primary hover:shadow-btn-primary-hover">
          ZUM PROSPEKT
        </button>
      </div>
    </Link>
  );
}

export default OfferCard;
